var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcXMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.078 5.32976C17.5177 4.89008 18.2306 4.89008 18.6702 5.32976C19.1099 5.76944 19.1099 6.48231 18.6702 6.92199L13.5922 12L18.6702 17.078C19.1099 17.5177 19.1099 18.2306 18.6702 18.6702C18.2306 19.1099 17.5177 19.1099 17.078 18.6702L12 13.5922L6.92199 18.6702C6.48231 19.1099 5.76944 19.1099 5.32976 18.6702C4.89008 18.2306 4.89008 17.5177 5.32976 17.078L10.4078 12L5.32976 6.92199C4.89008 6.48231 4.89008 5.76944 5.32976 5.32976C5.76944 4.89008 6.48231 4.89008 6.92199 5.32976L12 10.4078L17.078 5.32976Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcXMark);
export default __webpack_public_path__ + "static/media/ic_x_mark.40dd430eaddc7b02b187bfcff39c6af2.svg";
export { ForwardRef as ReactComponent };